<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from '@/services/Monitor';
import modalAddEnvConfig from '@/components/modals/application/modalAddEnvConfig';
import modalEditEnvConfig from '@/components/modals/application/modalEditEnvConfig';
import Swal from "sweetalert2";

export default {
  components: {Layout, PageHeader, modalAddEnvConfig, modalEditEnvConfig},
  page: {
    title: "Environment Configuration Parameters",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  created() {
    this.getTenants()
    this.getEnvConfigDefinition()
  },
  computed: {
    filteredTableData() {
      let items = this.tableData;

      if (this.appliedGroup) {
        items = items.filter(item => item.group === this.appliedGroup);
      }

      return this.filterItems(items, this.filter);
    },

    filteredTableDataMissing() {
      return this.filterItems(this.tableDataMissing, this.filterMissing);
    },

    paginationTotalRows() {
      return this.filteredTableData.length;
    },

    paginationTotalRowsMissing() {
      return this.filteredTableDataMissing.length;
    },
  },
  watch: {
    filter() {
      this.currentPage = 1;
    },
    filterMissing() {
      this.currentPageMissing = 1;
    },
  },
  methods: {
    filterItems(items, searchTerm) {
      const search = (searchTerm || '').trim().toLowerCase();
      if (!search) {
        return items;
      }

      return items.filter(item =>
        Object.values(item).some(
          val => val != null && String(val).toLowerCase().includes(search)
        )
      );
    },

    modalAddNewEnvConfig() {
      this.$bvModal.show("add_new_env_config")
    },

    editDBConfig(configData, importMissing = false){
      if(importMissing === true){
        this.envConfigData = {
          ...configData,
          tenant: this.currentTenant,
          value: ''
        }
      }else{
        this.envConfigData = { ...configData }
      }

      this.$bvModal.show("edit_env_config")
    },

    getTenants() {
      Monitor.getTenants()
          .then((response) => {
            let tenants = response.data.tenants || []

            // Ensure COMMON is included at the top
            if (!tenants.includes('COMMON')) {
              tenants.unshift('COMMON')
            }

            this.tenants = tenants
          })
          .catch(error => {
          })
    },

    getTenantEnvConfig() {

      if(!this.currentTenant){
        return
      }

      this.tableData = []
      this.totalRows = 0
      this.currentPage = 1
      this.isBusy = true

      Monitor.getTenantEnvConfig(this.currentTenant)
          .then((response) => {
            this.tableData = response.data.data
            this.totalRows = this.tableData.length
            this.isBusy = false;
          })
          .catch(error => {
            this.tableData = []
          })
    },

    getMissingEnvConfig(){

      if(!this.currentTenant){
        return
      }

      this.tableDataMissing = []
      this.totalRowsMissing = 0
      this.currentPageMissing = 1
      this.isBusyMissing = true

      Monitor.getMissingEnvConfig(this.currentTenant)
          .then((response) => {
            this.tableDataMissing = response.data.data
            this.totalRowsMissing = this.tableDataMissing.length
            this.isBusyMissing = false;
          })
          .catch(error => {
            this.tableDataMissing = []
          })
    },

    getEnvConfigDefinition() {
      Monitor.getEnvConfigDefinition()
          .then((response) => {
            const data = response.data.data

            // Unique groups
            this.configGroups = [...new Set(data.map(item => item.group))];

            // Unique keys
            this.configKeys = [...new Set(data.map(item => item.key))];

            this.configDefinitions = data
          })
          .catch(error => {
            this.configGroups = []
            this.configKeys = []
            this.configDefinitions = []
          })
    },

    removeDBConfig(data) {
      Swal.fire({
        title: "Remove key " + data.key + " for tenant " + this.currentTenant +"?",
        text: "Remove key!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          Monitor.removeEnvConfig(data.key, this.currentTenant)
              .then((response) => {
                const res = response.data.data || false;
                const error = response.data.error || '';
                if (!res && !error) {
                  this.refreshData();
                  this.successmsg("Environment Configuration Key Successfully Removed");
                } else {
                  this.failedmsg("Environment Configuration Key Removal Failed");
                }
              })
              .then((response) => {
                  this.refreshData();
                  this.successmsg("Environment Configuration Key Successfully Removed");
              })
              .catch((error) => {
                this.failedmsg('Fail!', error);
              });
        }
      });
    },

    applyFilters() {
      this.appliedGroup = this.selectedGroup;
      this.currentPage = 1;
      this.refreshData();
    },

    refreshData(){
      this.getTenantEnvConfig()
      this.getMissingEnvConfig()
      this.getEnvConfigDefinition()
    },

  },
  data() {
    return {
      title: "Environment Configuration Parameters",
      items: [
        {
          text: "Application",
          href: "/application",
        },
        {
          text: "Environment Configuration Parameters",
          active: true,
        },
      ],
      isBusy: false,
      error: null,
      showModal: false,
      modalData: {},
      tenants: [],
      currentTenant: '',
      selectedGroup: '',
      appliedGroup: '',
      configGroups: [],
      configKeys: [],
      configDefinitions: [],
      envConfigData: [],
      tableDataMissing: [],
      totalRowsMissing: 0,
      currentPageMissing: 1,
      isBusyMissing: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterMissing: null,
      filterOn: [],
      filterOnMissing: [],
      sortBy: "key",
      sortByMissing: "key",
      sortDesc: false,
      sortDescMissing: false,
      fieldsMissing: [
        {
          key: "key",
          label: "Key",
          sortable: false,
        },
        {
          key: "group",
          label: "Group",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key: "tenant_required",
          label: "Tenant Required",
          sortable: false,
        },
        {
          key: "common_required",
          label: "Common Required",
          sortable: false,
        },
        {
          key: "is_secret",
          label: "Is Secret",
          sortable: false,
        },
        {
          key: "description",
          label: "Description",
          sortable: false,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        }
      ],
      fields: [
        {
          key: "key",
          label: "Key",
          sortable: false,
        },
        {
          key: "group",
          label: "Group",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key: "tenant_required",
          label: "Tenant Required",
          sortable: false,
        },
        {
          key: "common_required",
          label: "Common Required",
          sortable: false,
        },
        {
          key: "is_secret",
          label: "Is Secret",
          sortable: false,
        },
        {
          key: "description",
          label: "Description",
          sortable: false,
        },
        {
          key: "value",
          label: "Value",
          sortable: false,
        },
        {
          key: "source",
          label: "Source",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
    };
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2 align-items-end">

              <!-- Tenant -->
              <div class="col-md-2 mb-3">
                <label class="form-label">Select Tenant</label>
                <select class="form-select"
                        v-model="currentTenant">
                  <option value="">Select Tenant</option>
                  <option v-for="tenant in tenants"
                          :key="tenant"
                          :value="tenant">
                    {{ tenant }}
                  </option>
                </select>
              </div>

              <!-- Group -->
              <div class="col-md-3 mb-3">
                <label class="form-label">Filter By Group</label>
                <select class="form-select"
                        v-model="selectedGroup"
                >
                  <option value="">Select Group</option>
                  <option v-for="group in configGroups"
                          :key="group"
                          :value="group">
                    {{ group }}
                  </option>
                </select>
              </div>

              <div class="col-md-2 mb-3">
                <button type="button"
                        class="btn btn-primary waves-effect waves-light w-100"
                        @click="applyFilters">
                  <i class="mdi mdi-filter me-2"></i>
                  Filter
                </button>
              </div>

              <!-- Buttons -->
              <div class="col-md-5 mb-3">
                <div class="d-flex gap-2 justify-content-end flex-wrap">

                  <button type="button"
                          class="btn btn-success waves-effect waves-light"
                          @click="modalAddNewEnvConfig">
                    <i class="mdi mdi-plus me-2"></i>
                    Add New Env Config
                  </button>

                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">

                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="table-responsive mb-0">
                  <b-table
                      :busy="isBusy"
                      :items="filteredTableData"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      show-empty
                      empty-text="No Data Found"
                  >

                    <template v-slot:cell(source)="data">
                      <span v-if="data.item.source == 'db'"
                            class='badge bg-primary font-size-14'>{{ data.item.source }}</span>
                      <span v-else class='badge bg-secondary font-size-14'>{{ data.item.source }}</span>
                    </template>

                    <template v-slot:cell(tenant_required)="data">
                      <span v-if="data.item.tenant_required == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(common_required)="data">
                      <span v-if="data.item.common_required == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(is_secret)="data">
                      <span v-if="data.item.is_secret == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(value)="data">
                      <span class="env-config-value" v-if="data.item.is_secret == '1'">********</span>
                      <span class="env-config-value" v-else>{{ data.item.value }}</span>
                    </template>

                    <template v-slot:cell(action)="data">
                      <ul class="list-inline mb-0 env-config-actions">
                        <li class="list-inline-item" v-if="data.item.source != 'file'">
                          <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Config Key"
                             @click="editDBConfig(data.item)">
                            <i class="uil uil-pen font-size-18"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="javascript:void(0);" class="text-danger" title="Remove Config Key" v-if="data.item.source != 'file'"
                             @click="removeDBConfig(data.item)">
                            <i class="uil uil-trash-alt font-size-18"></i>
                          </a>
                        </li>
                      </ul>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                  </b-table>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="paginationTotalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Missing keys table -->
            <div class="row mt-5">
              <div class="col-12">
                <h5 class="text-uppercase mb-2">Missing Environment Keys for This Tenant</h5>
              </div>

              <div class="col-sm-12 col-md-6 ms-auto mb-3">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filterMissing"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="table-responsive mb-0">
                  <b-table
                      :busy="isBusyMissing"
                      :items="filteredTableDataMissing"
                      :fields="fieldsMissing"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPageMissing"
                      :sort-by.sync="sortByMissing"
                      :sort-desc.sync="sortDescMissing"
                      show-empty
                      empty-text="No Data Found"
                  >

                    <template v-slot:cell(tenant_required)="data">
                      <span v-if="data.item.tenant_required == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(common_required)="data">
                      <span v-if="data.item.common_required == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(is_secret)="data">
                      <span v-if="data.item.is_secret == '1'" class='font-size-14'>Yes</span>
                      <span v-else class='font-size-14'>No</span>
                    </template>

                    <template v-slot:cell(source)="data">
                      <span v-if="data.item.source == 'db'"
                            class='badge bg-primary font-size-14'>{{ data.item.source }}</span>
                      <span v-else class='badge bg-secondary font-size-14'>{{ data.item.source }}</span>
                    </template>

                    <template v-slot:cell(action)="data">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a href="javascript:void(0);" class="px-2 text-primary" title="Add Missing Config Key to Tenant"
                             @click="editDBConfig(data.item, true)">
                            <i class="mdi mdi-plus font-size-18"></i>
                          </a>
                        </li>
                      </ul>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                  </b-table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPageMissing"
                        :total-rows="paginationTotalRowsMissing"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- MODALS -->
    <modalAddEnvConfig @onRefresh="refreshData" :tenants="tenants" :configGroups="configGroups" :configKeys="configKeys" :configDefinitions="configDefinitions"></modalAddEnvConfig>
    <modalEditEnvConfig @onRefresh="refreshData" :configData="envConfigData" :configGroups="configGroups" :configKeys="configKeys" :configDefinitions="configDefinitions"></modalEditEnvConfig>
    <!-- /MODALS -->

  </Layout>
</template>

<style scoped>
.env-config-value {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.env-config-actions {
  white-space: nowrap;
}
</style>
